import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

// `light` is the pro-ish green card, `dark` is the sky collabs card.
const accentOf = ($variant: 'light' | 'dark') =>
  $variant === 'dark' ? LandingHero.creator : LandingHero.pro;

export const Wrap = styled.div`
  width: 100%;
  padding: 8.8rem 7.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.4rem;

  ${MOBILE} {
    padding: 4.8rem 2.4rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;
  width: 100%;
  max-width: 112rem;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div<{ $variant: 'light' | 'dark' }>`
  position: relative;
  background: ${({ $variant }) => accentOf($variant).cardBg};
  border: 0.1rem solid ${({ $variant }) => accentOf($variant).cardBorder};
  border-radius: 2.4rem;
  padding: 3.8rem 3.4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  backdrop-filter: blur(1.4rem);
  -webkit-backdrop-filter: blur(1.4rem);

  ${MOBILE} {
    padding: 2.4rem 2.2rem;
  }
`;

export const Title = styled.div<{ $variant: 'light' | 'dark' }>`
  font-size: 1.9rem;
  font-weight: 900;
  letter-spacing: -0.025rem;
  color: ${LandingHero.textPrimary};
`;

export const Description = styled.div<{ $variant: 'light' | 'dark' }>`
  font-size: 1.4rem;
  line-height: 1.55;
  color: ${LandingHero.textMuted};
`;

export const BulletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  margin-top: auto;
`;

export const Bullet = styled.div<{ $variant: 'light' | 'dark' }>`
  display: flex;
  gap: 1.2rem;
  font-size: 1.4rem;
  color: ${LandingHero.textBody};
`;

export const BulletMark = styled.span<{ $variant: 'light' | 'dark' }>`
  color: ${({ $variant }) => accentOf($variant).kicker};
  font-weight: 900;
`;
